// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const CrossDiscIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm3.71 12.29a1 1 0 010 1.42 1 1 0 01-1.42 0L12 13.41l-2.29 2.3a1 1 0 01-1.42 0 1 1 0 010-1.42l2.3-2.29-2.3-2.29a1 1 0 011.42-1.42l2.29 2.3 2.29-2.3a1 1 0 011.42 1.42L13.41 12z" fill="currentColor"/></svg>'} />;

(CrossDiscIcon as any).displayName = 'CrossDiscIcon';

export default CrossDiscIcon;
